import type { Conversation } from '@customTypes/chat';
import { Stack } from '@mantine/core';
import React, { useMemo } from 'react';

export const ConversationsList = ({
  conversations,
  renderItem: RenderItem
}: {
  conversations: Conversation[];
  renderItem: React.ComponentType<{ conversation: Conversation }>;
}) => {
  const sortedConversations = useMemo(
    () => conversations.sort((a, b) => b.newMessageCount - a.newMessageCount),
    [conversations]
  );

  return (
    <Stack gap={0}>
      {sortedConversations.map((conversation) => (
        <RenderItem
          key={conversation.conversationId}
          conversation={conversation}
        />
      ))}
    </Stack>
  );
};
